import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

import { GetPaginationRes } from '@pp/core/entities';
import { withOrgId } from '@pp/core/helpers';
import { environment } from '@pp/environment';

import { Rates } from './rate-conditions';
import { ApiSettings } from './shell.entities';

const API_SETTINGS = 'settings/';

@Injectable()
export class ShellApi {
  readonly #http = inject(HttpClient);
  protected translate = inject(TranslateService);

  getRates(): Observable<GetPaginationRes<Rates>> {
    const api = environment.apiHost + API_SETTINGS + 'currencies/rates';

    return this.#http.get<Rates[]>(api, { headers: withOrgId() }).pipe(
      map((ratesList: Rates[]) => {
        const paginatedRates: GetPaginationRes<Rates> = {
          items: ratesList.filter(rate => rate.info?.length),
        };

        return paginatedRates;
      }),
    );
  }

  getCryptoMarket(): Observable<GetPaginationRes<any>> {
    const api = environment.apiHost + API_SETTINGS + 'crypto-market';

    return this.#http.get<GetPaginationRes<any>>(api);
  }

  getTotalBalance(currencyId: number): Observable<string> {
    return this.#http
      .get<any>(`${environment.apiHost}dashboard/balance/total`, {
        headers: withOrgId(),
        params: { currency_id: currencyId },
      })
      .pipe(map(res => res.balance));
  }

  getSettings(): Observable<ApiSettings> {
    return this.#http.get<ApiSettings>(`${environment.apiHost}${API_SETTINGS}`);
  }

  changeAgentFeatureAvailability(agent_feature_availability: boolean): Observable<void> {
    return this.#http.patch<void>(`${environment.apiHost}${API_SETTINGS}agent_feature/`, { agent_feature_availability });
  }

  generateTelegramLink(orgId: number): Observable<string> {
    return this.#http
      .post<{ url: string }>(`${environment.apiHost}${API_SETTINGS}support/t/key/generate/`, { orgId })
      .pipe(map(res => res.url));
  }
}
